import { Component, Input } from '@angular/core';
import { ToolbarMenu } from '../../../../model/general.model';

@Component({
  selector: 'home-box',
  templateUrl: './home-box.component.html',
  styleUrls: ['./home-box.component.scss']
})
export class HomeBoxComponent {

  @Input() items: ToolbarMenu[] = [];
}
